import script from "./data-dashboard.vue?vue&type=script&setup=true&lang=js"
export * from "./data-dashboard.vue?vue&type=script&setup=true&lang=js"

import "./data-dashboard.vue?vue&type=style&index=0&id=3349cd1a&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3349cd1a"]])

export default __exports__